module.exports = __webpack_public_path__ + "img/remove_src_2.b21e2788.webp";